module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAIAAADp3DFZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEWSURBVDhP5ZHtSsMwFIa9/5twpAstmdA546r7cGV2UKQQWnQFWxVcpRJWArkCu3n2kSYVFH8IPr/el4SHc5IT+Rv8G4t4ZiO328HIslEHnzo0SN/gyITJwiOKCWXZGroUZTzpYTLPoGvollXQswfJO7QD2cyxvVRAU9EsT+NuP9xPodB+1LQUc0IWKyhNYg8PU8gKTcurTwbMPLaUy4lFE8gK2kYPFF3FkBuUt8TxCygK+uvGnuVGHMoRIp+2LqtbJE8ocsZpebxXlS9cZA1bvshkqeGPN2cY2/3r2V0YTM83+TJMfIIuohKuKJgtWyr+EjMWsmRZrD9nqPIW0RcWI1vR6B7aju9aakQNxB0/sBj4OxYpPwBpRPeSR98H8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/68.png
// module id = 48
// module chunks = 1 2 3 4 5 6 7 8